import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useState, FC } from "react";
import { testimonials } from "./constant";

export const TestimonialSection: FC = () => {
  const [current, setCurrent] = useState(0);

  return (
    <section className="bg-ashShade-18 text-blueShades-4">
      <div className="py-16 md:py-24 px-4 md:px-16">
        <div className="flex flex-col justify-center items-center gap-10 referral-container">
          <p className="text-4xl md:text-5xl font-SatoshiBold text-center">
            What users are saying
          </p>
          <blockquote className="text-2xl font-satoshi font-semibold leading-relaxed text-center w-full md:w-[80%]">
            “{testimonials[current].message}”
          </blockquote>
          <div className="text-center">
            <p className="text-lg font-semibold font-satoshi">
              {testimonials[current].name}
            </p>
            <p className="text-base text-ashShade-16 font-SatoshiMedium">
              {testimonials[current].title}
            </p>
          </div>
          <div className="flex justify-center space-x-2 -mt-6">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-2 h-2 rounded-full transition ${
                  idx === current ? "bg-[#5A616A]" : "bg-[#D1D5DB]"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
